import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import store from '../store';

import validationEn from '../lang/en/validator';
import validationHe from '../lang/he/validator';
import validationZh from '../lang/zh/validator';

Validator.extend('login', {
    async validate(value) {
        console.log('val', value);
        return {
            valid: value !== 0,
        };
    },
    getMessage(field, data, params) {
        return validationEn.messages.login;
    },
});

Validator.extend('unique', {
    async validate(value) {
        return {
            valid: value !== 0,
        };
    },
    getMessage: validationEn.messages.unique,
});

Validator.extend('enabled', {
    async validate(value) {
        return {
            valid: value !== 0,
        };
    },
    getMessage: validationEn.messages.enabled,
});

Validator.extend('locked', {
    async validate(value) {
        return {
            valid: value !== 0,
        };
    },
    getMessage: validationEn.messages.locked,
});

Vue.use(VeeValidate, {
    fieldsBagName: 'fieldsValidation',
    locale: store.getters['auth/currentLang'],
    events: 'blur',
    dictionary: {
        en: validationEn,
        he: validationHe,
        zh: validationZh,
    },
});



// WEBPACK FOOTER //
// ./src/plugins/validator.js